import { materialStateEnum } from '../material';

export const materialStateColors: Record<number, { background: string; text: string }> = {
    [materialStateEnum.NEW]: { background: 'lightgreen', text: 'black' },
    [materialStateEnum.PRESENT]: { background: 'lightgrey', text: 'black' },
    [materialStateEnum.REMOVE]: { background: 'rgb(255,200,100)', text: 'black' },
};

export const getMaterialStateColor = (state: number, position: 'background' | 'text'): string => {
    return materialStateColors[state]?.[position] ?? '';
};
